import { render, staticRenderFns } from "./postBorn.vue?vue&type=template&id=82486b96&"
import script from "./postBorn.vue?vue&type=script&lang=js&"
export * from "./postBorn.vue?vue&type=script&lang=js&"
import style0 from "./postBorn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports